import React, { useState } from "react";
import { CoverImage } from "./CoverImage";
import { CardContent } from "./CardContent";
import { ScheduleDialog } from "@/components/mentoria/ScheduleDialog";
import { MentorshipOfferingProps } from "./types";

export const MentorshipOfferingCard: React.FC<MentorshipOfferingProps> = (props) => {
  const [isScheduleDialogOpen, setIsScheduleDialogOpen] = useState(false);

  const handleCardClick = () => {
    if (props.onCardClick) {
      props.onCardClick(props.id);
    }
  };

  const handleScheduleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsScheduleDialogOpen(true);
  };

  return (
    <>
      <div 
        className="bg-[#1A2233] border border-[#222A35] rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:border-[#00B6F0]/50 cursor-pointer"
        onClick={handleCardClick}
      >
        <CoverImage 
          coverImageUrl={props.coverImageUrl}
          title={props.title}
          isActive={props.isActive}
        />
        
        <CardContent 
          {...props}
          handleScheduleClick={handleScheduleClick}
        />
      </div>

      {/* Schedule Dialog */}
      {isScheduleDialogOpen && props.mentorId && (
        <ScheduleDialog
          open={isScheduleDialogOpen}
          onOpenChange={setIsScheduleDialogOpen}
          mentorId={props.mentorId}
          offeringId={props.id}
          offeringTitle={props.title}
          description={props.description}
          coverImageUrl={props.coverImageUrl}
          isGroup={props.isGroup}
          maxParticipants={props.maxParticipants}
          gameName={props.game?.name}
          gameId={props.game?.id}
          price={props.price}
        />
      )}
    </>
  );
};

export default MentorshipOfferingCard;
